import { render, staticRenderFns } from "./EnrolmentAgreementEditor.vue?vue&type=template&id=9647da80&scoped=true"
import script from "./EnrolmentAgreementEditor.vue?vue&type=script&lang=js"
export * from "./EnrolmentAgreementEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9647da80",
  null
  
)

export default component.exports